
import React from "react";

interface Step {
  number: string;
  title: string;
  description: string;
}

interface HowItWorksProps {
  title?: string;
  steps?: Step[];
}

export const HowItWorks = ({
  title = "Here's how it works",
  steps = [
    {
      number: "1",
      title: "Reserve Your Time Slot",
      description: "Fill out our quick form and then you'll be directed to a Stripe payment page.",
    },
    {
      number: "2",
      title: "Show Up and Record",
      description: "We'll meet you outside to bring you in the pod to get started.",
    },
    {
      number: "3",
      title: "Receive Files Same Day",
      description: "After, we'll upload all the recordings to a google drive link to send over.",
    },
  ],
}: HowItWorksProps) => {
  return (
    <section className="w-full bg-white">
      <div className="py-20 container mx-auto px-4 md:px-8 lg:px-16">
        <h2 className="text-4xl font-bold text-center mb-16 text-studio-stone">
          {title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`p-8 rounded-3xl ${
                index % 2 === 0 ? "bg-[#D3E4FD]" : "bg-[#FFDEE2]"
              }`}
            >
              <div className="text-6xl font-bold mb-6 text-studio-stone/80">
                {step.number}
              </div>
              <h3 className="text-xl font-semibold mb-4 text-studio-stone">
                {step.title}
              </h3>
              <p className="text-studio-stone/80">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
